import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SupportImg from '../../assets/support-mobile-lady.png';

export type customSupportProps = React.PropsWithChildren<{}>;

const Support = ({ children }: customSupportProps) => {
  const [show, setShow] = useState(false);
  return (
    <Container
      className={`custom-support ${show ? 'clicked' : ''} p-7 bg-white rounded`}
    >
      <Row
        className="m-0 d-flex justify-content-between clickable-row"
        onClick={() => setShow(!show)}
      >
        <Col className={'d-flex flex-column align-items-center p-0 col-4 pe-3'}>
          <img src={SupportImg} alt="support-img" className="support-img" />
        </Col>
        <Col className={'p-0 col-8 ps-3'}>
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-sub fw-bold lh-xs">Need help?</span>
            <span>
              <FontAwesomeIcon
                icon={light('chevron-down')}
                className="arrow-svg"
              />
            </span>
          </div>
        </Col>
      </Row>
      {show && <Row className="m-0">{children}</Row>}
    </Container>
  );
};

export default Support;
